<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="160px"
        v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              <el-input v-model="formData.specName" placeholder="请输入品种规格" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="typeId" label="类型名称">
              <!-- <el-select v-model="formData.typeId" clearable filterable placeholder="请选择类型名称">
                <el-option v-for="(item, index) of typeArr" :value="item.typeId" :label="item.typeName"
                  :key="index"></el-option>
              </el-select> -->

              <el-cascader v-model="formData.typeId" :options="typeTreeList"
                :props="{ emitPath: false, label: 'typeName', value: 'typeId', children: 'childNode', checkStrictly: true }"
                placeholder="请选择类型" clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="priceDiff" label="价格差(元)">
              <el-input-number v-model="formData.priceDiff"></el-input-number>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="currentPrice" label="当前单价(元)">
              <el-input-number
                v-model="formData.currentPrice"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col> -->
          <!-- </el-row>
        <el-row> -->
          <el-col :span="12">
            <el-form-item prop="isPublished" label="是否发布">
              <el-radio-group v-model="formData.isPublished">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isDisplay" label="是否展示">
              <el-radio-group v-model="formData.isDisplay">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isBulkOil" label="是否散油">
              <el-radio-group v-model="formData.isBulkOil">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- </el-row>

        <el-row> -->
          <el-col :span="12">
            <el-form-item prop="unit" label="单位">
              <el-input v-model="formData.unit" placeholder="请输入单位" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="productCode" label="商品编号">
              <!-- <el-select
                v-model="formData.productCode"
                placeholder="请选择商品编号"
              >
                <el-option
                  v-for="(item, index) of productCodeList"
                  :value="item.dicCode"
                  :label="item.dicValue"
                  :key="index"
                ></el-option>
              </el-select> -->
              <el-input v-model="formData.productCode" placeholder="请输入商品编号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderNum" label="排序">
              <el-input-number :min="1" v-model="formData.orderNum"></el-input-number>
            </el-form-item>
          </el-col>
          <!-- 暂时隐藏用友系数输入项，保留字段数据及默认值，恢复时取消此注释。
          <el-col :span="12">
            <el-form-item prop="yonyouCoefficient" label="用友系数">
              <el-input v-model.trim="formData.yonyouCoefficient" placeholder="请输入大于0的用友系数" clearable />
              <div class="coefficient-tip">默认1，T+数量乘系数，金额除系数</div>
            </el-form-item>
          </el-col>
          -->
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="图片" prop="specImage">
              <div v-if="formData.specImage" class="images-wrap">
                <i class="el-icon-error close-icon" @click="delImage"></i>
                <el-image style="width: 100%; height: 100%" :src="formData.specImage"
                  :preview-src-list="[formData.specImage]" fit="cover" />
              </div>
              <el-upload v-else class="upload-demo" :action="$apis.common.uploadUrl" :limit="1"
                :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  图片大小不能超过10MB~
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import BigNumber from 'bignumber.js'

export default {
  name: 'GrainSpecificationsAdd',

  data() {
    return {
      typeArr: [],
      typeTreeList: [],
      formData: {
        typeId: '',
        specName: '',
        priceDiff: '',
        // currentPrice: '',
        isDisplay: '',
        isPublished: '',
        isBulkOil: '',
        unit: '',
        productCode: '',
        // 用友系数默认 1，以字符串提交，避免大数及小数被浏览器浮点运算改写。
        yonyouCoefficient: '1',
        specImage: '',
        orderNum: 1
      },
      rules: {
        // 与后端 DECIMAL(20,8) 一致：正数、整数最多十二位、小数最多八位。
        yonyouCoefficient: [
          { validator: this.validateYonyouCoefficient, trigger: ['blur', 'change'] }
        ],
        typeId: [
          {
            required: true,
            message: '请选择类型名称',
            trigger: ['blur', 'change']
          }
        ],
        specName: [
          {
            required: true,
            message: '请输入品种规格',
            trigger: ['blur', 'change']
          }
        ],
        priceDiff: [
          {
            required: true,
            message: '请输入价格差',
            trigger: ['blur', 'change']
          }
        ],

        // currentPrice: [
        //   {
        //     required: true,
        //     message: '请输入当前单价',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        isPublished: [
          {
            required: true,
            message: '请选择是否发布',
            trigger: ['blur', 'change']
          }
        ],
        isDisplay: [
          {
            required: true,
            message: '请选择是否展示',
            trigger: ['blur', 'change']
          }
        ],
        isBulkOil: [
          {
            required: true,
            message: '请选择是否散油',
            trigger: ['blur', 'change']
          }
        ],
        unit: [
          {
            required: true,
            message: '请输入单位',
            trigger: ['blur', 'change']
          }
        ],
        productCode: [
          {
            required: true,
            message: '请输入商品编码',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,

      productCodeList: [],

      dialogVisible: false,
      currentImageIndex: 0
    }
  },
  created() {
    this.loadDict()
    // this.loagType()
    this.loadGrainTreeList()
    if (this.specId) {
      this.loadData()
    }
  },
  computed: {
    specId() {
      return this.$route.query.specId
    }
  },
  methods: {
    // 保存前校验用友系数，空值、零、负数和超出精度的输入均不允许提交。
    validateYonyouCoefficient(rule, value, callback) {
      if (!/^\d{1,12}(\.\d{1,8})?$/.test(String(value)) || Number(value) <= 0) {
        callback(new Error('用友系数须大于0，整数最多12位，小数最多8位'))
        return
      }
      callback()
    },
    loadDict() {
      this.$axios
        .get(this.$apis.common.selectDicByList, {
          params: { dicType: 'goodsCode' }
        })
        .then(res => {
          this.productCodeList = res.goodsCode || []
        })
    },
    loagType() {
      this.$axios
        .get(this.$apis.grainType.selectYxOilTypeByList)
        .then(res => {
          console.log('res: ', res)
          this.typeArr = res.list || []
        })
    },

    loadGrainTreeList() {
      this.$axios.get(this.$apis.grainType.selectYxOilTypeByTree).then(res => {
        this.typeTreeList = res
      })
    },

    delImage() {
      this.formData.specImage = ''
    },
    handleSuccess(res) {
      console.log('res: ', res)
      const file = res.data
      this.formData.specImage = file.filePrefix + file.fileUrl
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    // 编辑时回显已保存的用友系数；历史空值按默认 1 展示。
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecBySpecId, {
          params: { specId: this.specId }
        })
        .then(res => {
          this.formData = {
            ...res,
            // 用普通十进制字符串回显，避免 0.00000001 被转换为科学计数法后无法通过校验。
            yonyouCoefficient: res.yonyouCoefficient == null ? '1' : new BigNumber(res.yonyouCoefficient).toFixed()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.grainSpecifications.insertYxOilSpec
          if (this.specId) {
            url = this.$apis.grainSpecifications.updateYxOilSpec
          }
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
/* 系数用途提示沿用表单布局，避免影响相邻字段。 */
.coefficient-tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
